@import '~style-sheet-helpers/core.less';

.forms-column {
  display: flex;
}

.icon {
  padding: 7px 6px;
}
